// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Debug: Check if environment variables are loaded
console.log('Environment check:', {
  hasApiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
  hasAuthDomain: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  hasProjectId: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID
});

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
console.log('Initializing Firebase app...');
const app = initializeApp(firebaseConfig);
console.log('Firebase app initialized successfully');

console.log('Initializing analytics...');
const analytics = getAnalytics(app);
console.log('Analytics initialized successfully');

console.log('Initializing auth...');
export const auth = getAuth(app);
console.log('Auth initialized successfully');

// Ensure auth is properly configured
auth.useDeviceLanguage();

// Debug: Log Firebase config (without sensitive data)
console.log('Firebase config:', {
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  databaseURL: firebaseConfig.databaseURL
});

// Configure auth providers
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

// Configure Google provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Configure Apple provider
appleProvider.addScope('email');
appleProvider.addScope('name');

export const database = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Function to connect to Firebase Emulators in development
const connectToEmulators = async () => {
  if (process.env.REACT_APP_USE_EMULATOR === 'true') {
    console.log('🔧 Connecting to Firebase Emulators...');
    
    try {
      // Connect to Functions, Auth, and Database Emulators
      const { connectFunctionsEmulator } = await import('firebase/functions');
      connectFunctionsEmulator(functions, '45.79.132.201', 5001);
      
      const { connectAuthEmulator } = await import('firebase/auth');
      connectAuthEmulator(auth, 'http://45.79.132.201:9099');
      
      const { connectDatabaseEmulator } = await import('firebase/database');
      connectDatabaseEmulator(database, '45.79.132.201', 9000);
      
      console.log('✅ Connected to Firebase Emulators');
    } catch (error) {
      console.error('❌ Failed to connect to Firebase Emulators:', error);
      console.log('Make sure Firebase emulators are running: firebase emulators:start --only functions');
    }
  } else {
    console.log('📡 Using production Firebase Functions');
  }
};

// Connect to emulators when in development
connectToEmulators().catch(console.error);
